import { useCallback, useEffect, useState } from "react";
import { cotizacionDetalleCheckout } from "../../../services/backend/cotizacionService";
import logger from "../../../shared/utils/logger";

const useCheckoutDetail = ({ cotizacionId }) => {
  const [checkoutDetail, setCheckoutDetail] = useState(null);

  const refreshCheckoutDetail = useCallback(async (targetCotizacionId) => {
    const id = String(targetCotizacionId || cotizacionId || "").trim();
    if (!id) {
      setCheckoutDetail(null);
      return;
    }
    try {
      const data = await cotizacionDetalleCheckout({ id_cotizacion: id });
      setCheckoutDetail(data || null);
    } catch (error) {
      logger.error("No fue posible obtener el detalle del checkout.", error);
      setCheckoutDetail(null);
    }
  }, [cotizacionId]);

  useEffect(() => {
    refreshCheckoutDetail();
  }, [refreshCheckoutDetail]);

  return { checkoutDetail, refreshCheckoutDetail };
};

export default useCheckoutDetail;